	// HS START
	window.onload = function() {
      
		function getParameterByName(product) {
			url = window.location.href;
			product = product.replace(/[\[\]]/g, "\\$&");
			var regex = new RegExp("[?&]" + product + "(=([^&#]*)|&|#|$)"),
				results = regex.exec(url);
			 if (!results) return null;
			 if (!results[2]) return '';
			 return decodeURIComponent(results[2].replace(/\+/g, " "));
			}
      
      function getParameterByName(prodsku) {
			url = window.location.href;
			prodsku = prodsku.replace(/[\[\]]/g, "\\$&");
			var regex = new RegExp("[?&]" + prodsku + "(=([^&#]*)|&|#|$)"),
				results = regex.exec(url);
			 if (!results) return null;
			 if (!results[2]) return '';
			 return decodeURIComponent(results[2].replace(/\+/g, " "));
			}
      
		var productTitle = getParameterByName('product');
      	var prodSku = getParameterByName('prodsku');
        if (prodSku == null)
            prodSku = "N/A";

        if (productTitle != null) {

          document.getElementById("ContactForm-body").innerHTML = 'Hello, I would like to enquire about '+productTitle+' '+prodSku+': ';
          document.getElementById("contactProductName").value = productTitle;
          document.getElementById("contactProductsku").value = prodSku;

        }

      
      
      
	};

// HS END